<template>
    <span
        :title="title || text"
        class="co pill mw-100"
        :class="{
            outline: outline,
            truncate: truncate,
            [variant]: true,
            iconleft: iconleft,
            iconright: iconright,
        }"
    >
        <div class="d-flex align-items-center w-100 h-100">
            <CoIcon v-if="iconleft" :name="iconleft" />
            <span class="mw-0 flex-fill"
                ><slot>{{ text }}</slot></span
            >
            <CoIcon v-if="iconright" :name="iconright" />
        </div>
    </span>
</template>
<style lang="less" scoped>
@import './CoPill.less';
</style>
<script>
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
export default {
    name: 'CoPill',
    components: {
        CoIcon,
    },
    props: {
        text: String,
        title: String,
        outline: {
            type: Boolean,
            default: false,
        },
        truncate: {
            type: Boolean,
            default: true,
        },
        variant: {
            default: 'normal',
            validators: (value) =>
                ['normal', 'mute', 'success', 'warning', 'primary', 'white', 'black', 'lightgrey', 'outline'].includes(
                    value
                ),
        },
        iconleft: {
            type: String,
            required: false,
        },
        iconright: {
            type: String,
            required: false,
            default: '',
        },
    },
};
</script>
